import React from "react";

import InternalLink from "components/InternalLink";

export default function Card(props) {
  let iconsize = props.iconsize ? props.iconsize : "md";
  let icon = `mdn-CardInstitutional-icon mdn-Icon-${props.icon} mdn-Icon--${iconsize}`;
  return (
    <>
      <InternalLink
        className="cred-card"
        link={props?.link}
        data-gtm-event-category={`minha-claro:meu-perfil"`}
        data-gtm-event-action="clique:card"
        data-gtm-event-label={props?.link}
        tabIndex={props?.tabIndex}
      >
        <div
          className={`mdn-CardInstitutional mdn-CardInstitutional--default ${
            props.inverse ? "mdn-CardInstitutional--inverse" : ""
          }`}
        >
          <span className={icon} aria-hidden="true"></span>
          <div className="mdn-CardInstitutional-content">
            <h3
              className={`mdn-Heading mdn-Heading--sm ${
                props.inverse ? "mdn-Heading--inverse" : ""
              }`}
            >
              {props.title}
            </h3>
            <p
              className={`mdn-Text mdn-Text--body  ${
                props.inverse ? "mdn-Text--inverse" : ""
              }`}
            >
              {props.text ? (
                <p
                  className={`mdn-Text mdn-Text--body ${
                    props.inverse ? "mdn-Text--inverse" : ""
                  }`}
                >
                  {props.text}
                </p>
              ) : null}
              {props.children}
            </p>
            <div
              className={`mdn-Link mdn-Link--arrow ${
                props?.inverse ? "mdn-Link--inverse" : ""
              }`}
            >
              {props?.linktext ? (
                <>
                  <InternalLink
                    className="mdn-Link-anchor"
                    link={props?.link}
                    data-gtm-event-category={`minha-claro:meu-perfil"`}
                    data-gtm-event-action="clique:card-link"
                    data-gtm-event-label={props.link}
                  >
                    {props?.linktext}
                  </InternalLink>
                  <i className="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm"></i>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </InternalLink>
    </>
  );
}
